import React, { useEffect } from "react";
import { GeneralTable } from "../GeneralComponents";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import moment from "moment";
import {
  Box,
  IconButton,
  makeStyles,
  Modal,
  Typography,
} from "@material-ui/core";
import { CardBody } from "reactstrap";
import CloseIcon from "mdi-react/CloseIcon";

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "start",
    whiteSpace: "pre-wrap",
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export default function TabletGestionDocumentos() {
  const [radicaciones, setRadicaciones] = React.useState([]);
  const classes = useStyles();
  const [documentoSeleccionado, setDocumentoSeleccionado] =
    React.useState(null);
  const [idDocumentoRad, setIdDocumentoRad] = React.useState(null);
  const [showPdf, setShowPdf] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);
  const [dates, setDates] = React.useState({
    start: new Date(),
    end: new Date(),
  });

  useEffect(() => {
    loadRadicaciones();
  }, [page, pageSize, dates, setDates]);

  const loadDocumentosRadicados = async (idRadicacion) => {
    return await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "documento-radicados/listar?idRadicacion=" +
        idRadicacion,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data[0].id_gd_documentos_radicados;
      })
      .catch((error) => {
        console.error("Error:", error);
        return null;
      });
  };

  const loadRadicaciones = async () => {
    const startDate = dates.start
      ? moment(dates.start).format("YYYY-MM-DD")
      : "";
    const endDate = dates.end ? moment(dates.end).format("YYYY-MM-DD") : "";
    const params = new URLSearchParams({
      page: page + 1,
      page_size: pageSize,
      start_date: startDate,
      end_date: endDate,
    }).toString();

    await fetch(
      process.env.REACT_APP_PUBLIC_URL + `radicacion/listar?${params}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const dataRows = data.results.map((row) => ({
          ...row,
          id: row.id_gd_radicacion, // <-- usar la llave única como id
        }));
        setRadicaciones(dataRows);
        setRowCount(data.count);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const columns = [
    {
      field: "fecha_radicacion",
      headerName: "FECHA Y HORA",
      type: "date",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY HH:mm:ss") : "",
    },
    {
      field: "numero_radicado",
      headerName: "# DE RADICADO",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "asunto",
      headerName: "ASUNTO",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "nombre_remitente",
      headerName: "REMITENTE",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    /* {
      field: "nombre_dependencia",
      headerName: "DEPENDENCIA RESPONSABLE",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "nombre_usuario",
      headerName: "USUARIO RESPONSABLE",
      type: "string",
      flex: 1.3,
      disableColumnMenu: true,
      sortable: false,
    }, */
    {
      field: "tiempo_tramite",
      headerName: "DÍAS RESTANTES",
      type: "string",
      flex: 1.3,
      disableColumnMenu: true,
      sortable: false,
    },
  ];

  const actionsList = [
    {
      title: "Ver documento",
      ariaLabel: "view-document",
      icon: <PictureAsPdfIcon />,
      onClick: async (row) => {
        setDocumentoSeleccionado(row);
        const idDoc = await loadDocumentosRadicados(row.id_gd_radicacion);
        setIdDocumentoRad(idDoc);
        setShowPdf(true);
      },
    },
  ];

  return (
    <>
      <CardBody style={{ padding: 30 }}>
        <GeneralTable
          title=""
          titleAlert="Radicación"
          buttonText=""
          columns={columns}
          rows={radicaciones}
          initialFormData={{}}
          width={"70%"}
          actionsList={actionsList}
          isModalRadication={true}
          rowCount={rowCount}
          pageSize={pageSize}
          page={page}
          handlePageChange={handlePageChange}
          handlePageSizeChange={handlePageSizeChange}
          isRadicacion={true}
          dates={dates}
          setDates={setDates}
          /* formData={formData}
        setFormData={setFormData} */
          /*onActivate={onActivate}
        onInactivate={onInactivate}
        enableUpdate={false}
        enableDocumentarytype={false}
        enableView
        enableActivate
        loadList={loadDocumentos} */
        />
      </CardBody>
      {showPdf ? (
        <Modal
          open={showPdf}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div
            className="paperAppointment-flex"
            style={{ width: "100%", margin: 10 }}
          >
            <IconButton
              style={{ float: "right" }}
              onClick={() => {
                setShowPdf(false);
              }}
            >
              <CloseIcon />
            </IconButton>
            <iframe
              id="pdfV"
              width="1000"
              height="700"
              src={
                process.env.REACT_APP_PUBLIC_URL +
                "gestion-documento/ver/" +
                idDocumentoRad +
                "/" +
                sessionStorage.getItem("token")
              }
            ></iframe>
          </div>
        </Modal>
      ) : null}
    </>
  );
}
